import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {

    static targets = [
        "input",
        "progressBar",
        "submitButton",
        "uploadedPath",
        "log",
        "uploadId",
        "closeButton",
        "dropzone",
        "form",
        "progressText",
        "filterButton"
    ]

    connect() {
        console.log("connect file upload controller")

        this.processingProgress = null

        this.createProcessingProgress()
        this.subscribe()

        this.dropzoneTarget.addEventListener("dragover", (e) => {
            e.preventDefault()
        })

        this.dropzoneTarget.addEventListener("drop", (e) => {
            e.preventDefault()

            const file = e.dataTransfer.files[0]

            if (!file) return

            this.inputTarget.files = e.dataTransfer.files
            this.uploadFile()
        })

        this.modal = this.element.closest(".modal")

        if (this.modal) {
            this.modal.dataset.keepOpen = "true"

            this.modal.addEventListener(
                "hidden.bs.modal",
                () => {
                    console.log("disconnect file upload controller")
                    this.unsubscribe()
                }
            )
        }
    }

    disconnect() {
        console.log("disconnect file upload controller")

        this.unsubscribe()

        if (this.processingProgressContainer) {
            this.processingProgressContainer.remove()
            this.processingProgressContainer = null
        }
    }

    createProcessingProgress() {
        if (this.processingProgressContainer) return

        const container = document.createElement("div")

        container.className = "mt-3"

        this.logTarget.insertAdjacentElement(
            "afterend",
            container
        )

        this.processingProgressContainer = container
    }

    subscribe() {
        this.channel = consumer.subscriptions.create(
            {
                channel: "LongOperationsChannel",
                upload_id: this.uploadIdTarget.value
            },
            {
                received: (data) => {

                    switch(data.type) {

                        case "log":

                            this.appendLog(data.message)

                            break

                        case "progress":

                            this.updateProgress(
                                data.message,
                                data.current,
                                data.total
                            )

                            break

                        case "finished":

                            this.completeProgress()

                            this.appendLog(data.message)

                            this.submitButtonTarget.disabled = true
                            this.closeButtonTarget.disabled = false

                            if (data.fromdt && data.todt) {

                                this.fromdt = data.fromdt
                                this.todt = data.todt

                                this.filterButtonTarget.disabled = false
                            }

                            break
                    }
                }
            }
        )
    }

    unsubscribe() {
        if (this.channel) {
            consumer.subscriptions.remove(this.channel)
            this.channel = null
        }
    }

    appendLog(message) {
        const lines =
            this.logTarget.value
                .split("\n")
                .filter(v => v.length > 0)

        lines.push(message)

        this.logTarget.value =
            lines.join("\n")

        this.logTarget.scrollTop =
            this.logTarget.scrollHeight
    }

    uploadFile() {
        const file = this.inputTarget.files[0]

        if (!file) return

        // RESET UI

        this.progressBarTarget.style.width = "0%"
        this.progressBarTarget.innerText = "0%"

        this.submitButtonTarget.disabled = true
        this.closeButtonTarget.disabled = true

        this.uploadedPathTarget.value = ""

        this.logTarget.value = ""

        this.processingProgress = null
        this.renderProcessingProgress()

        this.appendLog(`Выбран файл: ${file.name}`)

        const formData = new FormData()

        formData.append("file", file)

        const xhr = new XMLHttpRequest()

        xhr.open("POST", "/upload_file")

        const token = document.querySelector(
            'meta[name="csrf-token"]'
        ).content

        xhr.setRequestHeader("X-CSRF-Token", token)

        xhr.upload.addEventListener("progress", (e) => {

            if (!e.lengthComputable) return

            const percent = Math.round(
                (e.loaded / e.total) * 100
            )

            this.progressBarTarget.style.width =
                `${percent}%`

            this.progressBarTarget.innerText =
                `${percent}%`
        })

        xhr.onload = () => {

            if (xhr.status !== 200) {
                this.appendLog("Ошибка загрузки файла")
                return
            }

            const response =
                JSON.parse(xhr.responseText)

            this.uploadedPathTarget.value =
                response.path

            this.submitButtonTarget.disabled =
                false

            this.appendLog("Файл загружен")
        }

        xhr.onerror = () => {
            this.appendLog("Ошибка загрузки файла")
        }

        xhr.send(formData)
    }

    async submit(e) {
        e.preventDefault()

        this.submitButtonTarget.disabled = true
        this.closeButtonTarget.disabled = true

        this.processingProgress = null
        this.renderProcessingProgress()

        this.appendLog("Запуск обработки...")

        const formData =
            new FormData(this.formTarget)

        try {
            const response = await fetch(
                this.formTarget.action,
                {
                    method: "POST",
                    body: formData,
                    headers: {
                        "X-CSRF-Token":
                        document.querySelector(
                            'meta[name="csrf-token"]'
                        ).content,
                        "Accept": "application/json"
                    }
                }
            )

            if (!response.ok) {
                this.appendLog(
                    "Ошибка запуска обработки"
                )

                this.submitButtonTarget.disabled =
                    false

                this.closeButtonTarget.disabled =
                    false
            }

        } catch (error) {
            console.error(error)

            this.appendLog(
                "Ошибка запуска обработки"
            )

            this.submitButtonTarget.disabled =
                false

            this.closeButtonTarget.disabled =
                false
        }
    }

    updateProgress(message, current, total) {
        this.processingProgress = {
            message,
            current,
            total
        }

        this.renderProcessingProgress()
    }

    completeProgress() {
        if (!this.processingProgress) return

        const total =
            Number(this.processingProgress.total) || 0

        if (total > 0) {
            this.processingProgress.current = total
        }

        this.renderProcessingProgress()
    }

    renderProcessingProgress() {
        if (!this.processingProgressContainer) {
            this.createProcessingProgress()
        }

        this.processingProgressContainer.innerHTML = ""

        if (!this.processingProgress) {
            return
        }

        const current =
            Number(this.processingProgress.current) || 0

        const total =
            Number(this.processingProgress.total) || 0

        const percent =
            total > 0
                ? Math.min(
                    100,
                    Math.max(
                        0,
                        Math.round(
                            current / total * 100
                        )
                    )
                )
                : 0

        const wrapper =
            document.createElement("div")

        wrapper.className = "mb-3"

        const header =
            document.createElement("div")

        header.className =
            "d-flex justify-content-between align-items-center mb-1 gap-3"

        const message =
            document.createElement("span")

        message.className =
            "small text-body-secondary"

        message.textContent =
            this.processingProgress.message || ""

        const counter =
            document.createElement("span")

        counter.className =
            "small text-body-secondary text-nowrap"

        counter.textContent =
            `${current}/${total}`

        header.append(
            message,
            counter
        )

        const progress =
            document.createElement("div")

        progress.className =
            "progress position-relative"

        progress.style.height = "28px"

        progress.setAttribute(
            "role",
            "progressbar"
        )

        progress.setAttribute(
            "aria-valuenow",
            percent
        )

        progress.setAttribute(
            "aria-valuemin",
            "0"
        )

        progress.setAttribute(
            "aria-valuemax",
            "100"
        )

        const bar =
            document.createElement("div")

        bar.className =
            "progress-bar"

        bar.style.width =
            `${percent}%`

        const percentText =
            document.createElement("div")

        percentText.className =
            "position-absolute top-50 start-50 translate-middle fw-semibold"

        percentText.style.zIndex = "2"
        percentText.style.pointerEvents = "none"

        percentText.textContent =
            `${percent}%`

        progress.append(
            bar,
            percentText
        )

        wrapper.append(
            header,
            progress
        )

        this.processingProgressContainer.append(
            wrapper
        )
    }

    filterLastLoaded() {
        const url =
            new URL(window.location.href)

        url.searchParams.set(
            "updated_at.fromdt",
            this.fromdt
        )

        url.searchParams.set(
            "updated_at.todt",
            this.todt
        )

        window.location.href =
            url.toString()
    }
}